import { createContext, useContext } from 'react';
import { MasterDataService, findMasterData } from '../core';
import { type MasterDataProviderInterface, type MasterDataEntries } from './types/propType';

const MasterDataContext = createContext<Map<string, {}>>(new Map());

const MasterDataProvider = function ({ masterData, children }: MasterDataProviderInterface) {
  const masterDataMap = new Map(Object.keys(masterData).map((key: string) => [key, masterData[key]])) as Map<
    string,
    {}
  >;
  MasterDataService.setMasterDatas(masterDataMap);
  return <MasterDataContext.Provider value={masterDataMap}>{children}</MasterDataContext.Provider>;
};

function useMasterData<T = undefined>(key: string): T | undefined {
  const masterDataMap = useContext(MasterDataContext);
  return findMasterData<T>(masterDataMap, key);
}

export default MasterDataProvider;
export type { MasterDataProviderInterface, MasterDataEntries };
export { useMasterData };
